// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Link$Showside from "./Link.bs.js";
import * as Badge$Showside from "./Badge.bs.js";
import * as Facets$Showside from "../types/Facets.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
function FiltersFloatingButton$View(Props) {
  var positionOpt = Props.position;
  var count = Props.count;
  var handleClearButtonClick = Props.handleClearButtonClick;
  var handleMainButtonClick = Props.handleMainButtonClick;
  var position = positionOpt !== undefined ? positionOpt : "absolute";
  var renderIcon = function (param) {
    return React.createElement("div", {
      className: CSS$Showside.prefix("w-12 h-12 flex items-center justify-center")
    }, count !== 0 ? React.createElement(Badge$Showside.make, {
      text: String(count),
      position: "relative",
      color: /* InvertAccent */1,
      dataTestId: "filters-count"
    }) : React.createElement(Unicons$Showside.UilSlidersVAlt.make, {
      size: /* Px */{
        _0: 18
      },
      className: CSS$Showside.prefix("rotate-90 transform-gpu")
    }));
  };
  var renderLabel = function (param) {
    return React.createElement("div", {
      className: CSS$Showside.prefix("mr-1 text-xl font-semibold")
    }, "Filters");
  };
  var renderClearButton = function (param) {
    if (count > 0) {
      return React.createElement(Link$Showside.make, {
        children: null,
        unstyled: true,
        className: CSS$Showside.prefix("px-4 py-2 mx-1.5 relative cursor-pointer text-base text-main no-underline"),
        dataTestId: "filters-clear-all-badge",
        onClick: handleClearButtonClick
      }, React.createElement("div", {
        className: CSS$Showside.prefix("relative text-main")
      }, "Clear All"), React.createElement("div", {
        className: CSS$Showside.prefix("absolute inset-1 bg-main opacity-15 rounded-full")
      }));
    } else {
      return null;
    }
  };
  return React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["w-full pointer-events-none", position === "sticky" ? "sticky" : "absolute", "bottom-0 left-0 w-full", "flex", "items-center", "justify-center", "duration-300 transition-all", "mb-22"]))
  }, React.createElement(DataAttribute$Showside.make, {
    dataTestId: "plp-filters-button",
    children: React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["h-13.5", "border-1.5 border-solid border-accent", "rounded-full shadow-xl bg-accent text-main no-touch-highlight pointer-events-auto flex items-center", count === 0 ? "pr-3 pl-2" : "", "transform transition-transform duration-300", "scale-110", "cursor-pointer", "font-button"])),
      onClick: handleMainButtonClick
    }, renderIcon(undefined), renderLabel(undefined), renderClearButton(undefined))
  }));
}
FiltersFloatingButton$View.displayName = "FiltersFloatingButton.View";
var View = {
  make: FiltersFloatingButton$View
};
function FiltersFloatingButton(Props) {
  var positionOpt = Props.position;
  var onClick = Props.onClick;
  var position = positionOpt !== undefined ? positionOpt : "absolute";
  var match = RouterProvider$Showside.useRouter(undefined);
  var goTo = match.goTo;
  var route = match.route;
  var count = Belt_Option.mapWithDefault(match.productFilters, 0, Facets$Showside.length);
  var handleMainButtonClick = Curry.__1(onClick);
  var handleClearButtonClick = function (e) {
    e.stopPropagation();
    var tmp;
    if (typeof route === "number") {
      tmp = route;
    } else {
      switch (route.TAG | 0) {
        case /* Home */0:
          var data = route._0;
          tmp = {
            TAG: /* Home */0,
            _0: {
              homeType: data.homeType,
              filters: undefined,
              sort: data.sort
            }
          };
          break;
        case /* ListPage */1:
          var data$1 = route._0;
          tmp = {
            TAG: /* ListPage */1,
            _0: {
              listPageType: data$1.listPageType,
              viewPLP: data$1.viewPLP,
              filters: undefined,
              sort: data$1.sort
            }
          };
          break;
        default:
          tmp = route;
      }
    }
    Curry._3(goTo, undefined, undefined, tmp);
  };
  return React.createElement(FiltersFloatingButton$View, {
    position: position,
    count: count,
    handleClearButtonClick: handleClearButtonClick,
    handleMainButtonClick: handleMainButtonClick
  });
}
FiltersFloatingButton.displayName = "FiltersFloatingButton";
var make = FiltersFloatingButton;
export { View, make };
/* react Not a pure module */